<template>
  <div class="d-flex flex-column mb-3 mb-lg-0">
    <div class="d-flex align-start px-3 pt-3">
      <v-icon :color="'psorange'" class="mr-2">mdi-alert</v-icon>
      <span>{{ warningText }}</span>
    </div>
    <div class="d-flex flex-lg-row flex-wrap">
      <BaseInput
        name="itemDescription"
        :rules="{
          required: {
            required: true,
            fieldLabel: 'Description',
          },
        }"
        hideDetails
        class="pa-lg-3"
        :placeholder="
          $vuetify.breakpoint.lgAndUp
            ? 'Please provide a brief description of the item...'
            : ''
        "
        :label="
          !$vuetify.breakpoint.lgAndUp
            ? possession.form.descriptionFieldLabel
            : ''
        "
        v-model="possession.form.descriptionFieldValue"
        :class="[
          possession.form?.itemTypes?.length
            ? 'order-lg-2 flex-grow-1 col-lg-10'
            : 'flex-grow-1 col-lg-7',
        ]"
        :dense="$vuetify.breakpoint.lgAndUp"
      />
      <BaseInput
        name="itemValue"
        :rules="{
          required: {
            required: true,
            fieldLabel: 'Item value',
          },
          regex: {
            required: true,
            fieldLabel: 'Item value',
            pattern: regexPattern,
            customMessage:
              'Value format is invalid - please enter whole pounds only.',
          },
          min_currency_value: {
            minValue: possession.form.valueFieldMinValue,
            fieldLabel: 'Item value',
          },
        }"
        hideDetails
        :label="
          !$vuetify.breakpoint.lgAndUp ? possession.form.valueFieldLabel : ''
        "
        class="pa-lg-3"
        :class="[
          possession.form?.itemTypes?.length
            ? ' col-lg-4 col-7'
            : 'col-lg-3 col-7',
        ]"
        minWidth="200"
        :dense="$vuetify.breakpoint.lgAndUp"
        prefix="£"
        v-model="possession.form.valueFieldValue"
        validationMode="lazy"
        moneyFormat
      />
      <div class="d-flex justify-end order-lg-4 col-lg-2 pa-lg-3 align-end">
        <BaseButton
          depressed
          name="add"
          text="ADD"
          rounded
          :height="$vuetify.breakpoint.lgAndUp ? '40' : '60'"
          block
          dense
          :color="'psorange'"
          class="font-weight-bold font-18"
          type="submit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/BaseComponents/BaseButton";
import BaseInput from "@/components/BaseComponents/BaseInput";

export default {
  name: "LayoutDrawerCustomiseCoverFormBicycles",
  components: {
    BaseButton,
    BaseInput,
  },
  props: {
    possession: {
      type: Object,
      required: true,
    },
    regexPattern: {
      type: String,
      required: true,
    },
    warningText: {
      type: String,
      default: "Electric or motorised bicycles are not covered.",
    },
  },
};
</script>

<style lang="scss" scoped></style>
